import combineReducers from 'combine-reducers';
import type { ActionType, StateType } from 'typesafe-actions';
import { createReducer } from 'typesafe-actions';

import type { FieldSpec, TemplateDto } from '@/services/ws-bi/src/main/resources/rest-api';

import * as actions from './actions.tsx';

const fieldSpecs = createReducer<Record<string, FieldSpec | undefined> | null, ActionType<typeof actions>>(null).handleAction(
  actions.setFieldSpecs,
  (state, action) =>
    action.payload.properties.reduce(
      (records, fieldSpec) => ({
        ...records,
        [fieldSpec.name]: fieldSpec,
      }),
      {},
    ),
);

const availableCurrencies = createReducer<string[], ActionType<typeof actions>>([]).handleAction(
  actions.setFieldSpecs,
  (state, action) => action.payload.availableCurrencies ?? [],
);

const isSendModalOpened = createReducer<boolean, ActionType<typeof actions>>(false).handleAction(
  actions.setSendModalOpened,
  (state, action) => action.payload,
);

const operationsForAggregations = createReducer<Record<string, string[] | undefined>, ActionType<typeof actions>>({}).handleAction(
  actions.setOperationSpecs,
  (state, action) =>
    action.payload.aggregations.reduce((records, operationSpec) => ({ ...records, [operationSpec.type]: operationSpec.values }), {}),
);

const operationsForFilters = createReducer<Record<string, string[] | undefined>, ActionType<typeof actions>>({}).handleAction(
  actions.setOperationSpecs,
  (state, action) =>
    action.payload.filters.reduce((records, operationSpec) => ({ ...records, [operationSpec.type]: operationSpec.values }), {}),
);

const operationsForGroups = createReducer<Record<string, string[] | undefined>, ActionType<typeof actions>>({}).handleAction(
  actions.setOperationSpecs,
  (state, action) =>
    action.payload.groups.reduce((records, operationSpec) => ({ ...records, [operationSpec.type]: operationSpec.values }), {}),
);

const template = createReducer<TemplateDto | null, ActionType<typeof actions>>(null).handleAction(
  actions.setTemplate,
  (state, action) => action.payload,
);

const templates = createReducer<TemplateDto[], ActionType<typeof actions>>([])
  .handleAction(actions.setTemplates, (state, action) => action.payload)
  .handleAction(actions.removeTemplate, (state, action) => state.filter((t) => t.id !== action.payload));

const reducer = combineReducers({
  fieldSpecs,
  availableCurrencies,
  operationsForAggregations,
  operationsForFilters,
  operationsForGroups,
  template,
  isSendModalOpened,
  templates,
});

export const initialState: StateType<typeof reducer> = {
  fieldSpecs: null,
  availableCurrencies: [],
  operationsForAggregations: {},
  operationsForFilters: {},
  operationsForGroups: {},
  template: null,
  templates: [],
  isSendModalOpened: false,
};

export default reducer;
